import { render, staticRenderFns } from "./WebsitePublicPlaceList.vue?vue&type=template&id=45d2d6d2&scoped=true&lang=pug"
import script from "./WebsitePublicPlaceList.vue?vue&type=script&lang=ts"
export * from "./WebsitePublicPlaceList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d2d6d2",
  null
  
)

export default component.exports